export default __webpack_public_path__ + "static/media/sitePessoal.d9a031d0.png";